// @flow
import type { Reducer } from 'redux';
import type { Action } from './state';
import { combineReducersFlat } from './utils';
import VRReducer from './travelerInfo/vr';
import RestaurantsReducer from './travelerInfo/restaurants';
import AttractionsReducer from './travelerInfo/attractions';
import HotelsReducer from './travelerInfo/hotels';
import HomeReducer from './travelerInfo/home';
import FlightsReducer from './travelerInfo/flights';

import type { VrTravelerInfo } from './travelerInfo/vr';
import type { RestaurantsTravelerInfo } from './travelerInfo/restaurants';
import type { AttractionsTravelerInfo } from './travelerInfo/attractions';
import type { HotelsTravelerInfo } from './travelerInfo/hotels';
import type { HomeTravelerInfo } from './travelerInfo/home';
import type { FlightsTravelerInfo } from './travelerInfo/flights';

export type State = {|
  hotels?: HotelsTravelerInfo,
  vr?: VrTravelerInfo,
  restaurants?: RestaurantsTravelerInfo,
  attractions?: AttractionsTravelerInfo,
  home?: HomeTravelerInfo,
  flights?: FlightsTravelerInfo,
|};

export default ((combineReducersFlat(
  HotelsReducer,
  VRReducer,
  AttractionsReducer,
  RestaurantsReducer,
  HomeReducer,
  FlightsReducer,
): any): Reducer<State, Action>);
